import { constants as invoiceConstants } from '../../../../../mr_modules/dataAccess/commerce/lib/invoice-constants';

const state = {
  invoiceItemTags: {
    sub: 'SUBSCRIPTION',
    sub_addon: 'SUBSCRIPTION ADD-ON'
  },
  maxQuantity: 6,
  bulkOrderPromoId: 3746,
  perfectPairInstructionId: 526, //- not used to add anymore but need to keep for removing
  perfectPairOneTimePromo: 4138,
  perfectPairSubPromoIdOne: 4139,
  invoiceConstants,
  mensProductTypes: ['mens_hair_color'],
  urmProductCode: 'hcb_memb-hcb_memb',
  omniMembProductType: 'omni_memb',
  directMembershipProductCode: 'limitless_plus',
  directMembershipBulkPromoIdField: 'directMembershipBulkPromoId',
};

export default {
  namespaced: true,
  state
};
